import { render, staticRenderFns } from "./CocoLinkForm.vue?vue&type=template&id=8c4da298&scoped=true"
import script from "./CocoLinkForm.vue?vue&type=script&lang=ts"
export * from "./CocoLinkForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4da298",
  null
  
)

export default component.exports